import React from 'react';
import type { Location } from 'history';
import type { UtmMedium } from '@shared/utils/utmParameters/utmParameters.constants';

export type UtmParameters = Readonly<{
  utm_medium: UtmMedium;
  utm_source: string;
  utm_campaign: string;
  utm_content?: string;
}>;

// Includes UTM parameters and any extra query parameters for the destination URL.
export type RelativeUrlParameters = UtmParameters & Readonly<Record<string, string | undefined>>;

export const UtlQueryParams = {
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_campaign: 'utm_campaign',
  utm_content: 'utm_content',
} as const;

export interface NavigationOptions
  extends Readonly<{
    scrollToTop?: boolean;
    replace?: boolean;
  }> {}
export interface RoutesContextProps
  extends Readonly<{
    isAdminRoute: boolean;
    isGuestRoute: boolean;
    location: Location;
    utmQueryParameters?: UtmParameters;
    buildPath: (route: string) => string;
    goToAdmin: () => void;
    goToMe: () => void;
    setScrollToTop: () => void;
    goToAccountMeRoute: (route: string) => void;
    goToAdminRoute: (route: string) => void;
    goToExactRoute: (route: string, queryParams?: string) => void;
    buildRelativeUrl: (route: string, parameters: RelativeUrlParameters) => string;
    navigateWithUtm: (route: string) => void;
  }> {}

export const RoutesContext = React.createContext<RoutesContextProps | undefined>(undefined);
